import { render } from "./AssetTypeAdd.vue?vue&type=template&id=10f60ae0"
import script from "./AssetTypeAdd.vue?vue&type=script&lang=js"
export * from "./AssetTypeAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__